import React from 'react';

import { Container } from '@mui/material';

import classes from './NgzCustomersStatisticsRow.module.scss';
import { angularizeWithProviders } from '../../../shared/providers';
import { CustomersFatLostWidget } from '../CustomersFatLostWidget/CustomersFatLostWidget';
import { AvgPerformanceScoreChart } from '../AvgPerformanceScoreChart/AvgPerformanceScoreChart';

const NgzCustomersStatisticsRow = () => {
  return (
    <Container>
      <div className={classes.statisticRow}>
        <CustomersFatLostWidget />
        <AvgPerformanceScoreChart />
      </div>
    </Container>
  );
};

angularizeWithProviders(NgzCustomersStatisticsRow, 'ngzCustomersStatisticsRow', {});

export { NgzCustomersStatisticsRow };
